import { useState } from 'react';
import { RouteComponentProps } from 'react-router';
import {
  OfferFormValues, StoredOffer, emptyOfferFormValues, offerToFormValues,
} from '../components/OfferForm/offerFormLogic';

interface DuplicateLocationState {
  duplicateOffer?: StoredOffer
}

// Mirrors Events' duplicate: every field carries over (offerToFormValues never reads `id`, so it
// drops on its own); the save-time uniqueness guards force a change to whatever collides.
export function useDuplicateOfferFormValues(location: RouteComponentProps['location']): OfferFormValues {
  const state = location.state as DuplicateLocationState | undefined;
  const [formValues] = useState<OfferFormValues>(
    () => (state?.duplicateOffer ? offerToFormValues(state.duplicateOffer) : emptyOfferFormValues),
  );
  return formValues;
}
